import React from 'react';

const DeepKnob = ({ value, size = 150, valueColor = '#48db99', textColor = '#48db99', strokeWidth = 15 }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (value / 100) * circumference;

    return (
        <div className="deep-knob" style={{ width: size, height: size }}>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                <circle
                    className="deep-knob-range"
                    stroke="var(--surface-border, LightGray)"
                    strokeWidth={strokeWidth}
                    fill="transparent"
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                />
                <circle
                    className="deep-knob-value"
                    stroke={valueColor}
                    strokeWidth={strokeWidth}
                    fill="transparent"
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                    style={{ strokeDasharray: circumference, strokeDashoffset: offset }}
                />
                <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dy=".3em"
                    fill={textColor}
                    className="deep-knob-text"
                >{value}%</text>
            </svg>
        </div>
    );
};

export default DeepKnob;